if (!customElements.get('cart-notification')) {
  class CartNotification extends HTMLElement {
    constructor() {
      super();

      this.notification = document.getElementById('cart-notification');
      this.header = document.querySelector('sticky-header');
      
      // Define handleBodyClick before referencing it inside the constructor
      this.onBodyClick = this.handleBodyClick.bind(this);

      this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
      this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
        closeButton.addEventListener('click', this.close.bind(this))
      );
    }

    open() {
      this.notification.classList.add('animate', 'active');
      document.body.classList.add('overflow-hidden');

      this.notification.addEventListener(
        'transitionend',
        () => {
          this.notification.focus();
          if (typeof trapFocus === 'function') trapFocus(this.notification);
        },
        { once: true }
      );

      document.body.addEventListener('click', this.onBodyClick);
    }

    close() {
      this.notification.classList.remove('active');
      document.body.classList.remove('overflow-hidden');
      document.body.removeEventListener('click', this.onBodyClick);

      if (typeof removeTrapFocus === 'function') removeTrapFocus(this.activeElement);
    }

    renderContents(parsedState) {
      this.cartItemKey = parsedState.key;
      this.getSectionsToRender().forEach((section) => {
        const element = document.getElementById(section.id);
        if (element) {
          element.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.id],
            section.selector
          );
        }
      });

      if (this.header) this.header.reveal();
      this.open();
    }

    getSectionsToRender() {
      return [
        {
          id: 'cart-notification-product',
          selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
        },
        {
          id: 'cart-notification-button',
        },
        {
          id: 'cart-icon-bubble',
        },
      ];
    }

    getSectionInnerHTML(html, selector = '.shopify-section') {
      return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
    }

    // Renamed from BodyClick to handleBodyClick to match the constructor binding
    handleBodyClick(evt) {
      const target = evt.target;
      if (target.classList.contains('cart-notification') || (target !== this.notification && !target.closest('.drawer__inner'))) {
        this.close();
      }
    }

    setActiveElement(element) {
      this.activeElement = element;
    }
  }

  customElements.define('cart-notification', CartNotification);
}

window.toggleCartDetails = function(button) {
  const container = button.closest('.cart-item__properties-container');
  if (!container) return;
  const grid = container.querySelector('.js-details-grid');
  
  grid.classList.toggle('is-expanded');
  
  if (grid.classList.contains('is-expanded')) {
    grid.style.maxHeight = grid.scrollHeight + 'px';
    button.textContent = "Less details";
  } else {
    grid.style.maxHeight = '2.2rem';
    button.textContent = "More details";
  }
};